import React, { useState, useEffect, useMemo } from 'react';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';

import { isEqual } from 'lodash';
import { dashboardsSelector } from '@store/tempDashboard/selectors';
import * as tempDashboardActions from '@store/tempDashboard/actions';
import { updateDashboardById } from '@store/dashboards/update/actions';
import { useLastLocation } from 'react-router-last-location';
import { DASHBOARD_TYPE, PAGE_TYPE, SAVE_SERVICE_DASHBOARD_KEYS } from '@utils/constants';
import usePageTitle from '@src/hooks/usePageTitle';
import Threshold from './Threshold';
import Noc from './Noc';
import useInitSave from '@components/saving/useInitSave';
import { getPageKeyForSaveService } from '@utils/savedDashboard';
import { savingSelector } from '@store/noc/dashboard/selectors';
import useSaveSet, { SavingStateObjectType } from '@components/saving/useSaveSet';
import { Provider } from 'jotai';
import { buildDashboardStore } from '@src/atoms/utils';
const defaultStore = buildDashboardStore();

const NocDashboard = (props) => {
  const { pageType, nocStore, tabs, isSavedDashboard, store = defaultStore } = props;
  const [view, setView] = useState('noc');
  const { match, history } = props;
  const currentShareId = get(match, 'params.id', 'noc');

  const dashboards = useSelector(dashboardsSelector);
  const tempDashboardId = `saved-${currentShareId}`;
  const tempDashboard = dashboards[tempDashboardId];
  const dispatch = useDispatch();
  const lastLocation = useLastLocation();

  const savingState = useSelector(savingSelector);

  const pageTypeForSaveService = isSavedDashboard
    ? 'saved'
    : pageType === PAGE_TYPE.SHARING
      ? 'sharing'
      : SAVE_SERVICE_DASHBOARD_KEYS.NOC;
  const pageKeyForSaveService = getPageKeyForSaveService(
    pageTypeForSaveService,
    currentShareId,
    SAVE_SERVICE_DASHBOARD_KEYS.NOC,
  );

  const saveData: SavingStateObjectType = useMemo(() => {
    return {
      meta: {
        dashboardTypeId: DASHBOARD_TYPE.NOC,
      },
      config: savingState,
    };
  }, [savingState]);

  useInitSave(pageKeyForSaveService);

  useSaveSet({
    pageKey: pageKeyForSaveService,
    saveData,
  });

  usePageTitle({ text: 'Real Time' });

  useEffect(() => {
    const prevPath = lastLocation ? lastLocation.pathname : null;
    const resp = get(nocStore, 'dashboard.response');
    if (resp && resp.isSaved) {
      const key = `saved-${resp.id}`;
      if (dashboards[key] == null) {
        dispatch(
          tempDashboardActions.createSavedDashboard(
            resp.id,
            resp.name,
            DASHBOARD_TYPE.NOC,
            nocStore,
          ),
        );
      }
    }

    if (
      pageType === PAGE_TYPE.SHARING &&
      tabs.tabsData[currentShareId] &&
      !isEqual(nocStore, tabs.tabsData[currentShareId])
    ) {
      tabs.tabsData[currentShareId].config = nocStore;
      tabs.tabsData[currentShareId].unsaved = true;
      tabs.tabsData[currentShareId].isSaved = false;
    }

    if (pageType === PAGE_TYPE.SAVED_DASHBOARD && prevPath?.includes('noc/sharing')) {
      const { dashboard } = tempDashboard;
      setTimeout(() => {
        dispatch(updateDashboardById(currentShareId, tempDashboard.title, dashboard, false));
      }, 2000);
    }
  }, [nocStore]);

  return (
    <Provider store={store}>
      <React.Fragment>
        {view === 'noc' ? (
          <Noc
            pageType={pageType}
            currentShareId={currentShareId}
            history={history}
            setView={setView}
            pageKeyForSaveService={pageKeyForSaveService}
            {...props}
          />
        ) : (
          <Threshold setView={setView} {...props} />
        )}
      </React.Fragment>
    </Provider>
  );
};

export default NocDashboard;
